import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tokens } from '@companycam/slab-tokens';

import { mdiClose } from '@mdi/js';

import GeneralIcon from './GeneralIcon';

const Container = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${tokens.color_background_2_le};
  transition: all ease-in-out 150ms;

  :hover {
    transform: scale(1.15);
    transition: all ease-in-out 150ms;
  }
`;

const CloseButton = ({ onClick }) => (
  <Container
    data-testid="editor__close-button"
    href="#"
    onClick={(e) => {
      e.preventDefault();
      onClick();
    }}
  >
    <GeneralIcon icon={mdiClose} />
  </Container>
);

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CloseButton;
